import { SanitizedSectionArticle } from "@app/types/Cue";
import BasicCard from "@components/ArticleCard/BasicCard";
import { CardVariations } from "@components/ArticleCard/types";
import { isArticleUpdated } from "@util/helpers";
import cx from "classnames";

type PodcastsKeywordsStoriesProps = {
  article: SanitizedSectionArticle;
};

export default function PodcastsKeywordsStories({
  article,
}: PodcastsKeywordsStoriesProps): React.ReactElement {
  const {
    id,
    urlPath,
    title,
    kicker,
    sections,
    paywall,
    media,
    updated,
    edited,
    displaySetting,
  } = article;
  const variant: CardVariations = {
    image: {
      width: "w-full",
      position: "",
    },
    content: {
      width: "w-full",
      extraClass: "pt-3",
    },
    kicker: {
      color: "text-gray-515",
    },
    title: {
      color: "text-gray-850",
      size: "text-base lg:text-lg",
    },
  };

  return (
    <BasicCard
      rootClassName={cx(
        "story w-3/4 flex-shrink-0 snap-start flex-col",
        "md:w-1/3 md:flex-shrink"
      )}
      id={id}
      slug={urlPath}
      title={displaySetting.displayHeadline || title}
      kicker={kicker?.fields?.[0]?.value}
      paywall={paywall?.contentAccess === "1"}
      variations={variant}
      media={media?.at(0)}
      edited={isArticleUpdated(updated, edited) ? edited : undefined}
      updated={updated}
      hasUpdatedTimestampDisplay={displaySetting?.hasUpdatedTimeDisplayed}
      defaultImage={{ directoryName: sections?.at(0)?.uniqueName || "" }}
    />
  );
}
